export default function redirectStudentHome(){ window.location.replace("/"); }
